import React from "react";

interface GhostWorklistRowsProps extends React.HTMLAttributes<HTMLDivElement> {
  count?: number;
}

// Cold-paint placeholder for the worklist list region. Mirrors CaseRow's exact
// geometry (px-4 py-2.5 border-b, w-10 count + two-line content) so the swap to
// real rows produces ZERO layout shift. No spinner. No expanded-preview skeleton
// (rows are never expanded on cold paint).
export const GhostWorklistRows: React.FC<GhostWorklistRowsProps> = ({ count = 10, ...rest }) => (
  <div {...rest}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} data-ghost-worklist-row className="px-4 py-2.5 border-b border-border">
        <div className="flex items-center gap-3 animate-pulse">
          <div className="w-10 h-4 bg-surface-2 rounded-xs shrink-0" />
          <div className="flex-1 min-w-0 space-y-1">
            <div className="h-4 bg-surface-2 rounded-xs w-2/3" />
            <div className="h-3 bg-surface-2 rounded-xs w-1/2" />
          </div>
          <div className="w-6 h-4 bg-surface-2 rounded-xs shrink-0" />
        </div>
      </div>
    ))}
  </div>
);
